// extracted by mini-css-extract-plugin
export var content = "ImageLink-module--content--0ec14";
export var date = "ImageLink-module--date--0c884";
export var img = "ImageLink-module--img--b2f57";
export var item = "ImageLink-module--item--90af6";
export var picture = "ImageLink-module--picture--6541e";
export var title = "ImageLink-module--title--51215";